import { useMediaQuery } from "react-responsive";

export const MOBILE_MAX_WIDTH = 820;

const isIosStandalone = (): boolean =>
  typeof navigator !== "undefined" && (navigator as any).standalone === true;

const isWebView = (): boolean => {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent;
  if (ua.includes("BeviajudaApp")) return true;
  if ((window as any).ReactNativeWebView) return true;
  if (/; wv\)/.test(ua)) return true;
  return /(iPhone|iPod|iPad).*AppleWebKit/.test(ua) && !/Safari\//.test(ua);
};

export default function useIsMobileApp(): boolean {
  const isMobileWidth = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
  const isTouch = useMediaQuery({ query: "(pointer: coarse)" });
  const isStandalone = useMediaQuery({ query: "(display-mode: standalone)" });
  return isMobileWidth && isTouch && (isWebView() || isStandalone || isIosStandalone());
}
